import { Injectable, EventEmitter } from '@angular/core';
import { HttpService, SmBaseService, PagedResult } from '../../core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class TransactionStatusService extends SmBaseService {
	private _cache: { [statusId: number]: Observable<TransactionStatusModel> } = {};

	constructor(http: HttpService) {
		super(http, 'transactionstatus');
	}

	public onStatusesChanged: EventEmitter<any> = new EventEmitter();

	clearCache() {
		this._cache = {};
	}

	get(statusId: number, force: boolean = false): Observable<TransactionStatusModel> {
		if (this._cache[statusId] == null || force == true) {
			this._cache[statusId] = this._getAs<TransactionStatusModel>(statusId)
				.pipe(publishReplay(1))
				.pipe(refCount());
		}

		return this._cache[statusId];
	}

	getMenu(): Observable<{ [key: string]: TransactionSectionItemModel[] }> {
		return this._getAs<{ [key: string]: TransactionSectionItemModel[] }>('menu')
			.pipe(publishReplay(1))
			.pipe(refCount());
	}

	getSections(): Observable<TransactionSectionsModel> {
		return this._getAs<TransactionSectionsModel>('sections');
	}

	putSections(model: TransactionSectionsModel): Observable<TransactionSectionsModel> {
		this.clearCache();
		return this._putAs<TransactionSectionsModel>('sections', model);
	}

	getAlarms(): Observable<TransactionStatusAlarmModel[]> {
		return this._getAs<TransactionStatusAlarmModel[]>('alarms');
	}

	putAlarms(alarms: TransactionStatusAlarmModel[]): Observable<TransactionStatusAlarmModel[]> {
		return this._putAs<TransactionStatusAlarmModel[]>('alarms', alarms);
	}
}

export interface TransactionStatusAlarmModel {
	id: number;
	name: string;
	notifyAfter: number;
}

export interface TransactionStatusModel {
	id: number;
	name: string;
	enableNotifications: boolean;
	features: TransactionStatusFeature;
	isDefault: boolean;
	isSystem: boolean;
}

export const enum TransactionStatusType {
	NotSpecified,
	Default,
	PaymentInAdvance,
	CashOnDelivery,
	PersonalCollection,
}

export interface TransactionSectionsModel {
	maxCustomSections: number;
	custom: TransactionSectionItemModel[];
	system: TransactionSectionItemModel[];
}

export interface TransactionSectionItemModel {
	id: number;
	isEnabled: boolean;
	isDefault: boolean;
	name: string;
	count: number;
	// features: TransactionStatusFeature,
	// enableNotifications: boolean;
}

export const enum TransactionStatusFeature {
	none = 0,
	showFeedback = 1 << 0,
	showRefundState = 1 << 1
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/transaction-status.service.ts